/** Normalize hand-picked carousel post id lists from string / array / empty. */
export function normalizeCustomContentPostIds(postIds: unknown): string[] {
  if (postIds == null || postIds === "") return [];
  if (Array.isArray(postIds)) {
    return postIds.map(String).map((id) => id.trim()).filter(Boolean);
  }
  if (typeof postIds === "string") {
    return postIds
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean);
  }
  return [];
}

/**
 * Legacy link-in-bio custom content/products: drag writes the same sequence
 * to `post_ids` and `custom_order`. Newest/Oldest keep the membership list.
 * Custom order must not be replaced by the original pick order on save.
 */
export function customContentIdsForSave(
  postIds: unknown,
  customOrder: unknown,
  order: unknown,
): { postIds: string; customOrder: string } {
  const picks = normalizeCustomContentPostIds(postIds);
  const custom = normalizeCustomContentPostIds(customOrder);
  const membership = picks.length ? picks : custom;
  const isCustom = String(order || "").toUpperCase() === "CUSTOM";
  if (!isCustom) {
    const joined = membership.join(",");
    return { postIds: joined, customOrder: joined };
  }
  const allowed = new Set(membership);
  const ordered = custom.filter((id) => allowed.has(id));
  const seen = new Set(ordered);
  for (const id of membership) {
    if (!seen.has(id)) ordered.push(id);
  }
  const list = (ordered.length ? ordered : membership).join(",");
  return { postIds: list, customOrder: list };
}
